<div class="delegation-panel">

  <!-- Current Owner -->
  <div class="owner-card" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
      <div class="owner-avatar">{{ (currentOwnerName || 'U')[0].toUpperCase() }}</div>
      <div>
        <div class="owner-label">Current Owner</div>
        <div class="owner-name">{{ currentOwnerName || 'Unassigned' }}</div>
      </div>
    </div>
    <button mat-stroked-button color="primary" (click)="showForm = !showForm">
      <mat-icon>{{ showForm ? 'close' : 'swap_horiz' }}</mat-icon>
      {{ showForm ? 'Cancel' : 'Delegate' }}
    </button>
  </div>

  <!-- Delegation Form -->
  <div *ngIf="showForm" class="delegation-form" [formGroup]="form">
    <h4><mat-icon>transfer_within_a_station</mat-icon> Transfer Ownership</h4>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>New Owner *</mat-label>
      <mat-select formControlName="newOwnerId" (selectionChange)="onOwnerChange($event.value)">
        <mat-option *ngFor="let user of userList" [value]="user.id ?? user.userId">
          {{ user.name ?? user.userName }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.controls.newOwnerId.errors?.required">New owner is required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Reason for delegation</mat-label>
      <textarea matInput formControlName="reason" rows="3"
                placeholder="Briefly explain why you are delegating…"></textarea>
      <mat-hint align="end">{{ form.value.reason?.length || 0 }}/500</mat-hint>
    </mat-form-field>

    <div fxLayoutAlign="end center" fxLayoutGap="8px" style="margin-top:12px">
      <button mat-stroked-button (click)="showForm = false">Cancel</button>
      <button mat-raised-button color="warn"
              [disabled]="form.invalid || saving"
              (click)="submit()">
        <mat-spinner *ngIf="saving" diameter="18" style="display:inline-block"></mat-spinner>
        <span *ngIf="!saving">Confirm Transfer</span>
      </button>
    </div>
  </div>

  <!-- Delegation History -->
  <mat-expansion-panel *ngIf="history.length > 0" class="history-panel" [expanded]="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>history</mat-icon> &nbsp; Delegation History ({{ history.length }})
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div *ngFor="let h of history; trackBy: trackById; let last = last" class="history-item">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-icon class="history-icon">swap_horiz</mat-icon>
        <div class="history-content">
          <div class="history-line">
            <span class="hist-owner">{{ h.previousOwnerName }}</span>
            <mat-icon style="font-size:14px;width:14px;height:14px">arrow_forward</mat-icon>
            <span class="hist-owner">{{ h.newOwnerName }}</span>
          </div>
          <div class="history-meta">
            By {{ h.delegatedByName }} · {{ h.createdDate | date:'dd MMM yyyy' }}
          </div>
          <div *ngIf="h.reason" class="history-reason">"{{ h.reason }}"</div>
        </div>
      </div>
      <mat-divider *ngIf="!last"></mat-divider>
    </div>

  </mat-expansion-panel>

  <div *ngIf="history.length === 0 && !showForm" class="no-history">
    <mat-icon>swap_horiz</mat-icon>
    <span>No delegation history.</span>
  </div>

</div>
